export const SET_UPDATENOTIFICATIONS = "SET_UPDATENOTIFICATIONS";
export const SET_SECURITYNOTIFICATIONS = "SET_SECURITYNOTIFICATIONS";
export const SET_ONETIMECODENOTIFICATIONS = "SET_ONETIMECODENOTIFICATIONS";
export const SET_NOT_READ = "SET_NOT_READ";
export const SET_FILTER_AND_OPTIONS = "SET_FILTER_AND_OPTIONS";
